import {
	type CSSProperties,
	type ForwardedRef,
	forwardRef,
	type HTMLAttributes
} from 'react'
import { cn } from '@/helpers/utils'

type ElementType =
	| 'div'
	| 'span'
	| 'section'
	| 'article'
	| 'header'
	| 'footer'
	| 'nav'
	| 'aside'
	| 'main'

export type FlexboxProps<T extends ElementType = 'div'> = {
	render?: T
	justify?: CSSProperties['justifyContent']
	align?: CSSProperties['alignItems']
	direction?: CSSProperties['flexDirection']
	wrap?: CSSProperties['flexWrap']
	gap?: number
	fullWidth?: boolean
} & HTMLAttributes<HTMLElement>

/**
 * @deprecated Use native flex div with Tailwind classes instead
 */
export const Flexbox = forwardRef(
	<T extends ElementType = 'div'>(
		{
			justify,
			align,
			direction,
			gap,
			wrap,
			render,
			fullWidth,
			className,
			style,
			...rest
		}: FlexboxProps<T>,
		ref: ForwardedRef<HTMLDivElement>
	) => {
		const Component = render ?? 'div'

		return (
			<Component
				className={cn('flex', fullWidth && 'w-full', className)}
				ref={ref as ForwardedRef<HTMLDivElement>}
				style={{
					flexDirection: direction,
					justifyContent: justify,
					alignItems: align,
					gap: gap ? gap * 4 : undefined,
					flexWrap: wrap,
					...style
				}}
				{...rest}
			/>
		)
	}
)
Flexbox.displayName = 'Flexbox'
